import { useState } from "react";
import ScooterLogo from "../../assets/HeaderLogo.png";
import TnqTech from "../../assets/tnqTech.png";
import { Spinner } from "../ui/Skeleton";
import { API_BASE_URL } from "../../services/apiService/axiosInstance";
import useToaster from "../../hooks/useToaster";

let NewLoginPage = () => {
  let [loading, setLoading] = useState(false);
  let [disabled, setDisabled] = useState(false);
  const showToast = useToaster();
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <div className="h-[344px] w-[480px] rounded-md flex flex-col justify-evenly">
        <div className="flex justify-center">
          <img
            src={ScooterLogo}
            alt="Scooter Logo"
            className="w-[156px] h-[48px] object-contain"
          />
        </div>
        <div className="h-[200px] flex flex-col items-center justify-evenly border border-[#BBBFC3] rounded-md">
          <p className="text-[#35424D] text-[27px]">Sign In</p>
          <button
            className={`w-[416px] h-[40px] border-2 text-[16px] font-semibold rounded-md flex items-center justify-center
                        ${
                          disabled
                            ? "text-[#C2C6CA] border-[#C2C6CA]"
                            : "border-[#1C40CA] text-[#1C40CA] hover:bg-[#E1E6FF] active:bg-[#B8C7FE]"
                        }`}
            type="button"
              onClick={() => {
                if (!navigator.onLine) {
                  showToast("You are currently offline. Please check your internet connection !");
                  return;
                }
                setLoading(true)
                window.location.href = `${API_BASE_URL}/login`;
              }}
          >
            {loading && (
              <Spinner
                width="w-4"
                height="h-4"
                border="border-2"
                className="mr-3"
              />
            )}
            <span>Sign In With SSO</span>
          </button>
        </div>
        <div className="flex items-center justify-center">
          <p className="text-[#5D6871] text-[19px]">Powered By</p>
          <img
            src={TnqTech}
            alt="Tnq Logo"
            className="w-[95px] h-[14px] object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export { NewLoginPage };
